@if (features.devices?.swapped) {
  <div>
    <era-device-details-context-menu-ui [device]="device$ | async"></era-device-details-context-menu-ui>
  </div>
}